import { render, staticRenderFns } from "./stats.vue?vue&type=template&id=be9c9868"
import script from "./stats.vue?vue&type=script&lang=ts"
export * from "./stats.vue?vue&type=script&lang=ts"
import style0 from "./stats.vue?vue&type=style&index=0&id=be9c9868&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports